/**
 * Price Controller — Calcolo autonomo prezzi con arrotondamento per pezzo
 * Usa i tier scoperti da volume-tiers.liquid (window.__volumeTiers)
 * NON dipende dall'API Regios per il calcolo dei prezzi.
 * Gestisce: product-info + sticky ATC bar + sync quantità
 */
(function() {
  "use strict";

  var controller = {
    qtyIncrement: 1,
    root: null,
    debounceTimer: null,
    basePriceCents: 0,
    tiers: [],
    forceUpdate: false,
    domModified: false,
    productJsonCache: null,

    init: function() {
      var productInfo = document.querySelector('product-info');
      if (!productInfo) return;

      this.root = productInfo.closest('.shopify-section') || document;

      var qtyInc = parseInt(productInfo.dataset.qtyIncrement || '1', 10);
      if (isNaN(qtyInc) || qtyInc < 1) qtyInc = 1;
      this.qtyIncrement = qtyInc;

      this.basePriceCents = parseInt(productInfo.dataset.variantPrice || '0', 10);

      /* Pre-carica product JSON */
      this.loadProductJson();

      this.bindEvents();

      /* Mostra subito il prezzo base per prodotti con confezione */
      if (this.qtyIncrement > 1 && this.basePriceCents > 0) {
        this.recalculate();
      }

      /* Aspetta i tier dal volume-tiers snippet */
      if (window.__volumeTiers && window.__volumeTiers.length > 0) {
        this.tiers = window.__volumeTiers;
        this.forceUpdate = true;
        this.recalculate();
      }

      var self = this;
      document.addEventListener('volume-tiers:ready', function(e) {
        self.tiers = e.detail.tiers;
        self.forceUpdate = true;
        self.refreshVariantData();
        self.recalculate();
      });
    },

    loadProductJson: function() {
      var self = this;
      var path = location.pathname.split('?')[0];
      if (path.indexOf('/products/') === -1) return;

      fetch(path + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          self.productJsonCache = data.variants || [];
        })
        .catch(function() {});
    },

    bindEvents: function() {
      var self = this;

      /* Quantity change - cattura da TUTTA la pagina (product-info + sticky) */
      document.addEventListener('change', function(e) {
        if (e.target.matches('input[name="quantity"]')) {
          var newQty = parseInt(e.target.value, 10);
          if (isNaN(newQty)) return;

          /* Sincronizza qty tra product-info e sticky bar */
          var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
          document.querySelectorAll('input[name="quantity"]').forEach(function(input) {
            if (input !== e.target && parseInt(input.value, 10) !== newQty) {
              setter.call(input, newQty);
            }
          });

          self.debouncedRecalculate();
        }
      });

      /* Polling per sync tier attivo con qty reale */
      var lastQty = self.getQuantity();
      setInterval(function() {
        var currentQty = self.getQuantity();
        if (currentQty !== lastQty) {
          lastQty = currentQty;
          self.syncActiveTier(currentQty);
          self.debouncedRecalculate();
        }
      }, 300);

      /* Quantity buttons - cattura da TUTTA la pagina */
      document.addEventListener('click', function(e) {
        if (e.target.closest('.quantity__button')) {
          setTimeout(function() {
            /* Sincronizza dopo che il tema ha aggiornato il valore */
            var btn = e.target.closest('.quantity__button');
            var qtyInput = btn?.closest('quantity-input')?.querySelector('input[name="quantity"]');
            if (qtyInput) {
              var newQty = parseInt(qtyInput.value, 10);
              if (!isNaN(newQty)) {
                var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                document.querySelectorAll('input[name="quantity"]').forEach(function(input) {
                  if (input !== qtyInput && parseInt(input.value, 10) !== newQty) {
                    setter.call(input, newQty);
                  }
                });
              }
            }
            self.debouncedRecalculate();
          }, 50);
        }
      });

      /* Subscription toggle */
      document.addEventListener('change', function(e) {
        if (e.target.matches('input[type="radio"][name^="purchaseOption_"]') ||
            e.target.matches('.subscription-frequency-select')) {
          setTimeout(function() { self.debouncedRecalculate(); }, 200);
        }
      });

      /* Tier button clicks */
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-tier-btn]')) {
          setTimeout(function() { self.debouncedRecalculate(); }, 100);
        }
      });

      /* Polling per cambio variante (il tema non emette eventi standard) */
      var lastVariantId = self.getVariantId();
      setInterval(function() {
        var currentId = self.getVariantId();
        if (currentId && currentId !== lastVariantId) {
          lastVariantId = currentId;
          self.forceUpdate = true;
          self.domModified = false;
          self.updateVariantPrice(function() {
            self.refreshQtyIncrement();
            self.recalculate();
          });
        }
      }, 300);
    },

    refreshQtyIncrement: function() {
      var productInfo = document.querySelector('product-info');
      if (productInfo) {
        var qtyInc = parseInt(productInfo.dataset.qtyIncrement || '1', 10);
        if (isNaN(qtyInc) || qtyInc < 1) qtyInc = 1;
        this.qtyIncrement = qtyInc;
      }
    },

    refreshVariantData: function() {
      var productInfo = document.querySelector('product-info');
      if (!productInfo) return;

      this.refreshQtyIncrement();
      this.basePriceCents = parseInt(productInfo.dataset.variantPrice || '0', 10);
    },
    
    syncActiveTier: function(qty) {
      document.querySelectorAll('[data-volume-tiers]').forEach(function(c) {
        var buttons = c.querySelectorAll('[data-tier-btn]');
        if (buttons.length === 0) return;

        buttons.forEach(function(b) { b.classList.remove('volume-tiers__card--active'); });

        var lastMatch = null;
        buttons.forEach(function(b) {
          var tierQty = parseInt(b.getAttribute('data-tier-qty'), 10);
          if (qty >= tierQty) lastMatch = b;
        });

        if (lastMatch) {
          lastMatch.classList.add('volume-tiers__card--active');
        } else {
          buttons[0].classList.add('volume-tiers__card--active');
        }
      });
    },

    /**
     * Aggiorna basePriceCents dalla variante corrente.
     * Usa la cache del product JSON, con fallback a fetch.
     */
    updateVariantPrice: function(callback) {
      var variantId = this.getVariantId();
      if (!variantId) {
        if (callback) callback();
        return;
      }

      var self = this;

      function applyFromCache(variants) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) {
            self.basePriceCents = variants[i].price;
            var pi = document.querySelector('product-info');
            if (pi) pi.dataset.variantPrice = variants[i].price;
            if (callback) callback();
            return true;
          }
        }
        return false;
      }

      /* Prova dalla cache */
      if (this.productJsonCache && applyFromCache(this.productJsonCache)) {
        return;
      }

      /* Fetch product.js */
      var path = location.pathname.split('?')[0];
      fetch(path + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          self.productJsonCache = data.variants || [];
          if (!applyFromCache(self.productJsonCache)) {
            if (callback) callback();
          }
        })
        .catch(function() {
          if (callback) callback();
        });
    },

    debouncedRecalculate: function() {
      var self = this;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(function() {
        self.recalculate();
      }, 150);
    },

    getQuantity: function() {
      /* Prendi la qty dal primo input visibile */
      var inputs = document.querySelectorAll('input[name="quantity"]');
      for (var i = 0; i < inputs.length; i++) {
        var val = parseInt(inputs[i].value, 10);
        if (!isNaN(val) && val > 0) return val;
      }
      return this.qtyIncrement;
    },

    getVariantId: function() {
      var vid = new URLSearchParams(location.search).get('variant');
      if (vid) return parseInt(vid, 10);
      var input = document.querySelector('input[name="id"]');
      if (input && input.value) return parseInt(input.value, 10);
      return null;
    },

    fmt: function(amountEuros) {
      var s = amountEuros.toFixed(2).replace('.', ',');
      var parts = s.split(',');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '\u20AC' + parts[0] + ',' + parts[1];
    },

    /**
     * Trova la percentuale di sconto volume per la quantità data.
     */
    getDiscountPercent: function(quantity) {
      var pct = 0;
      for (var i = 0; i < this.tiers.length; i++) {
        if (quantity >= this.tiers[i].minQty && this.tiers[i].pct > 0) {
          pct = this.tiers[i].pct;
        }
      }
      return pct;
    },

    /**
     * Calcola prezzi con arrotondamento per pezzo (come Shopify Function).
     */
    calculatePrices: function(quantity) {
      var baseCents = this.basePriceCents;
      var discountPct = this.getDiscountPercent(quantity);

      var discountedCents = baseCents;
      if (discountPct > 0) {
        var discountAmount = Math.floor(baseCents * discountPct / 100);
        discountedCents = baseCents - discountAmount;
      }

      var totalSaleCents = discountedCents * quantity;
      var totalRegularCents = baseCents * quantity;

      return {
        unitSale: discountedCents / 100,
        unitRegular: baseCents / 100,
        totalSale: totalSaleCents / 100,
        totalRegular: totalRegularCents / 100,
        discountPct: discountPct,
        hasDiscount: discountPct > 0
      };
    },

    recalculate: function() {
      if (this.basePriceCents <= 0) return;

      var quantity = this.getQuantity();

      /* Se non ci sono tier ancora, mostra comunque il prezzo base per qty_increment */
      if (this.tiers.length === 0 && this.qtyIncrement > 1) {
        var fallbackPrices = {
          unitSale: this.basePriceCents / 100,
          unitRegular: this.basePriceCents / 100,
          totalSale: (this.basePriceCents * quantity) / 100,
          totalRegular: (this.basePriceCents * quantity) / 100,
          discountPct: 0,
          hasDiscount: false
        };
        this.updatePriceDisplay(fallbackPrices, quantity);
        return;
      }

      var prices = this.calculatePrices(quantity);

      /*
       * Skip aggiornamento DOM solo se:
       * - Non c'è qty_increment (prodotto singolo)
       * - Non c'è sconto volume attivo
       * - Non è un aggiornamento forzato (cambio variante / nuovi tier)
       * - Il DOM non è mai stato modificato dal controller
       */
      if (this.qtyIncrement <= 1 && !prices.hasDiscount && !this.forceUpdate && !this.domModified) return;
      this.forceUpdate = false;

      this.updatePriceDisplay(prices, quantity);
    },

    /**
     * Trova i container prezzo del prodotto principale + sticky bar.
     * Esclude product-card, bundle, correlati, recommendations.
     */
    getMainPriceContainers: function() {
      var containers = [];

      /* Prezzo nel product-info principale */
      var productInfo = document.querySelector('product-info');
      if (productInfo) {
        productInfo.querySelectorAll('.f-price').forEach(function(p) {
          if (!p.closest('.product-card') &&
              !p.closest('[data-bundle]') &&
              !p.closest('.frequently-bought') &&
              !p.closest('.bundle-correlati') &&
              !p.closest('.product-recommendations')) {
            containers.push(p);
          }
        });
      }

      /* Prezzo nella sticky ATC bar */
      document.querySelectorAll('sticky-atc-bar, sticky-atc-bar-minimalist').forEach(function(bar) {
        bar.querySelectorAll('.f-price').forEach(function(p) {
          containers.push(p);
        });
      });

      return containers;
    },

    updatePriceDisplay: function(prices, quantity) {
      var self = this;

      var displayTotal = prices.totalSale;
      var displayRegular = prices.totalRegular;
      var hasDiscount = prices.hasDiscount;

      var priceContainers = this.getMainPriceContainers();
      if (priceContainers.length === 0) return;

      priceContainers.forEach(function(container) {
        var saleBlock = container.querySelector('.f-price__sale');
        var regularBlock = container.querySelector('.f-price__regular');
        var hasPromo = container.classList.contains('f-price--promo-active');

        if (hasDiscount) {
          container.classList.add('f-price--on-sale');

          /* Nascondi il saving della promo quando c'è sconto volume */
          var promoSaving = container.querySelector('.on-sale-message.promo-saving');
          if (promoSaving) promoSaving.style.display = 'none';

          if (saleBlock) {
            saleBlock.style.display = '';
            var saleEl = saleBlock.querySelector('.f-price-item--sale');
            if (saleEl) saleEl.textContent = self.fmt(displayTotal);
            var regEl = saleBlock.querySelector('s');
            if (regEl) {
              regEl.textContent = self.fmt(displayRegular);
              regEl.style.display = '';
            }
            /* Ripristina visibilità del prezzo barrato */
            var regInSale = saleBlock.querySelector('.f-price-item--regular');
            if (regInSale) regInSale.style.display = '';
            if (regularBlock) regularBlock.style.display = 'none';
          } else if (regularBlock) {
            regularBlock.style.display = 'none';
            var newSale = container.querySelector('.f-price__sale-dynamic');
            if (!newSale) {
              newSale = document.createElement('div');
              newSale.className = 'f-price__sale f-price__sale-dynamic';
              container.insertBefore(newSale, regularBlock);
            }
            newSale.style.display = '';
            newSale.innerHTML =
              '<span class="f-price-item f-price-item--sale">' + self.fmt(displayTotal) + '</span>' +
              '<span class="f-price-item f-price-item--regular"><s>' + self.fmt(displayRegular) + '</s></span>';
          }

          self.updateSavingMessage(container, displayRegular, displayTotal);


          } else {
          /* Ripristina il saving della promo */
          var promoSaving = container.querySelector('.on-sale-message.promo-saving');
          if (promoSaving) promoSaving.style.display = '';

          /* Nascondi solo il saving creato dal volume controller */
          var volumeSaving = container.querySelector('.on-sale-message.volume-saving');
          if (volumeSaving) volumeSaving.style.display = 'none';
          /* Rimuovi on-sale solo se non c'è promo attiva server-side */
          if (!hasPromo) {
            container.classList.remove('f-price--on-sale');
          }

          var dynSale = container.querySelector('.f-price__sale-dynamic');
          if (dynSale) dynSale.style.display = 'none';

          if (regularBlock) {
            /* Ha un regular block: mostralo con il prezzo aggiornato */
            regularBlock.style.display = '';
            var regDisplay = regularBlock.querySelector('.f-price-item--regular');
            if (regDisplay) regDisplay.textContent = self.fmt(displayTotal);
            if (saleBlock && !hasPromo) saleBlock.style.display = 'none';
          } else if (saleBlock) {
            /* Non ha regular block: riusa il sale block mostrando solo il prezzo senza barrato */
            saleBlock.style.display = '';
            var saleOnlyEl = saleBlock.querySelector('.f-price-item--sale');
            if (saleOnlyEl) saleOnlyEl.textContent = self.fmt(displayTotal);
            /* Nascondi il prezzo barrato solo se non c'è promo */
            if (!hasPromo) {
              var regInSale2 = saleBlock.querySelector('.f-price-item--regular');
              if (regInSale2) regInSale2.style.display = 'none';
              var sInSale = saleBlock.querySelector('s');
              if (sInSale) sInSale.style.display = 'none';
            }
          }

          /* Nascondi solo il saving creato dal volume controller, non quello della promo */
          var volumeSaving = container.querySelector('.on-sale-message.volume-saving');
          if (volumeSaving) volumeSaving.style.display = 'none';
        }

        /* Prezzo al pezzo e pack info solo per prodotti con confezione */
        if (self.qtyIncrement > 1) {
          self.updateUnitPrice(container, prices.unitSale);
          self.updatePackInfo(quantity);
        }

        /* Segna che il DOM è stato modificato dal controller */
        self.domModified = true;
      });
    },

    updateUnitPrice: function(container, unitPrice) {
      var unitWrapper = container.querySelector('.f-price__unit-wrapper');
      if (unitWrapper) {
        var unitEl = unitWrapper.querySelector('[data-unit-price]');
        if (unitEl) unitEl.textContent = this.fmt(unitPrice);
        unitWrapper.classList.remove('hidden');
        unitWrapper.style.display = '';
        return;
      }

      var packInfo = container.querySelector('.f-price__pack-info');
      if (packInfo) {
        var perUnit = packInfo.querySelector('.f-price__per-unit');
        if (perUnit) {
          perUnit.textContent = '(' + this.fmt(unitPrice) + ' / Pz)';
        }
      }
    },

    updatePackInfo: function(quantity) {
      var packs = quantity / this.qtyIncrement;
      var label = packs === 1 ? 'confezione' : 'confezioni';

      document.querySelectorAll('.qty-pack-count').forEach(function(el) {
        el.textContent = quantity + ' pz = ' + packs + ' ' + label;
      });
    },

    updateSavingMessage: function(container, totalRegular, totalSale) {
      var savingAmount = totalRegular - totalSale;
      // Arrotondamento standard: .5+ arrotonda in eccesso, .4- arrotonda in difetto
      var savingPercent = Math.round((savingAmount / totalRegular) * 100);

      /* Cerca solo il saving del volume, non quello della promo */
      var el = container.querySelector('.on-sale-message.volume-saving');

      if (savingPercent <= 0) {
        if (el) el.style.display = 'none';
        return;
      }

      if (!el) {
        el = document.createElement('div');
        el.className = 'on-sale-message volume-saving';
        container.appendChild(el);
      }

      el.style.display = '';
      el.innerHTML = 'Risparmia ' + this.fmt(savingAmount) + ' (' + savingPercent + '%)';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { controller.init(); });
  } else {
    controller.init();
  }
})();